const STORAGE_KEY = 'argus.returnTo'
export function currentPath(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`
}
export function isSafeReturnPath(value: string | null | undefined): value is string {
  if (
    typeof value !== 'string' ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.includes('\\') ||
    Array.from(value).some((char) => char.charCodeAt(0) <= 32 || char.charCodeAt(0) === 127)
  )
    return false
  try {
    const url = new URL(value, window.location.origin)
    const path = decodeURIComponent(url.pathname)
    return (
      url.origin === window.location.origin &&
      !path.includes('\\') &&
      !Array.from(path).some((char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127) &&
      !path.startsWith('//') &&
      !/^\/(?:callback|auth(?:\/|$))/.test(path)
    )
  } catch {
    return false
  }
}
export function rememberReturnRoute(path: string = currentPath()): void {
  if (!isSafeReturnPath(path)) return
  try {
    window.sessionStorage.setItem(STORAGE_KEY, path)
  } catch {
    /* Storage can be unavailable in private mode. */
  }
}
export function takeReturnRoute(): string | null {
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY)
    window.sessionStorage.removeItem(STORAGE_KEY)
    return isSafeReturnPath(stored) ? stored : null
  } catch {
    return null
  }
}
